<template>
  <v-dialog v-model="dialog" persistent scrollable max-width="600" :fullscreen="$vuetify.breakpoint.xsOnly">
    <v-card>
      <v-form class="fdlg__form" @submit.prevent="save">
        <div class="fdlg__head">
          <div>
            <h2 class="fdlg__title">Adaugă comentariu</h2>
            <p class="fdlg__sub">{{ subtitle || "Demersul nu își schimbă etapa." }}</p>
          </div>
          <v-btn icon aria-label="Închide" @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text ref="body" class="fdlg__body">
          <section class="form-section">
            <div class="form-section__label"><v-icon small>mdi-message-text-outline</v-icon>Comentariu</div>
            <p class="form-section__note">
              Apare în istoricul demersului. Autorul și cine decide acum asupra demersului primesc o notificare.
            </p>
            <v-textarea
              v-model="comments"
              placeholder="De exemplu: unde se află echipamentul, ce s-a constatat, când puteți fi găsit"
              outlined
              auto-grow
              rows="3"
              maxlength="4000"
              :error-messages="error"
            ></v-textarea>
            <PhotoInput
              v-model="photos"
              purpose="comment"
              :max="6"
              label="Fotografii (opțional)"
              hint="Nu fotografiați etichetele cu parole — acestea se pun la echipament, în «Fotografie etichetă»."
              @uploading="uploading = $event"
              @error="$emit('error', $event)"
            />
          </section>
        </v-card-text>

        <div class="fdlg__foot">
          <v-spacer></v-spacer>
          <v-btn text large @click="close">Anulare</v-btn>
          <v-btn class="btn-green" large type="submit" :loading="saving" :disabled="uploading">
            <v-icon left>mdi-content-save-outline</v-icon>Salvează
          </v-btn>
        </div>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import * as api from "@/views/approval/api";
import * as helper from "@/helper/helper";
import PhotoInput from "@/components/files/PhotoInput.vue";

// A comment on a demer at any time (POST /requests/:id/comments): text and/or photos, the stage does not move.
// open(requestId, subtitle) shows it; emits saved(comment), success(message), error(message).
export default {
  name: "AddCommentDialog",
  components: { PhotoInput },
  data() {
    return {
      dialog: false,
      requestId: null,
      subtitle: "",
      comments: "",
      photos: [],
      uploading: false,
      saving: false,
      error: "",
    };
  },
  watch: {
    comments() {
      this.error = "";
    },
    photos() {
      this.error = "";
    },
  },
  methods: {
    open(requestId, subtitle = "") {
      this.requestId = requestId;
      this.subtitle = subtitle;
      this.comments = "";
      this.photos = [];
      this.error = "";
      this.dialog = true;
      helper.scrollToTop(this);
    },
    close() {
      this.dialog = false;
    },
    async save() {
      if (this.saving || this.uploading || !this.requestId) return;
      const comments = this.comments.trim();
      if (!comments && this.photos.length === 0) {
        this.error = "Scrieți comentariul sau atașați o fotografie";
        return;
      }
      this.saving = true;
      try {
        const saved = await api.addRequestComment(this.requestId, {
          comments,
          file_ids: this.photos.map((p) => p.id),
        });
        this.$emit("success", "Comentariul a fost adăugat");
        this.$emit("saved", saved);
        this.dialog = false;
      } catch (error) {
        console.error("Error adding comment:", error);
        const message = error.response && error.response.data && error.response.data.message;
        this.$emit("error", (Array.isArray(message) ? message.join("; ") : message) || "Comentariul nu a fost salvat. Încercați din nou.");
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
